import * as XLSX from 'xlsx';
import { PilgrimGuideLink } from '../types/pilgrimGuide';

export const exportPilgrimGuideLinks = (links: PilgrimGuideLink[]) => {
  try {
    const rows = links.map(link => ({
      'Pilgrim Name': link.pilgrimName,
      'Passport Number': link.passportNumber,
      'Email': link.email || '-',
      'Phone': link.mobileNumber || '-', // Added Phone number field
      'Gender': link.gender === 'male' ? 'Male' : 'Female',
      'Country': link.residenceCountry,
      'Package': link.packageName,
      'Pilgrim Type': link.pilgrimType,
      'Nusuk Group': link.nusukGroup,
      'Guide': link.guideName,
      'Organizer': link.organizerName,
      'Status': link.status.charAt(0).toUpperCase() + link.status.slice(1),
      'Is Owner': link.isOwner === false ? 'No' : 'Yes'
    }));

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(rows);

    // Set column widths
    ws['!cols'] = [
      { wch: 30 }, // Pilgrim Name
      { wch: 15 }, // Passport
      { wch: 25 }, // Email
      { wch: 15 }, // Phone (added)
      { wch: 10 }, // Gender
      { wch: 20 }, // Country
      { wch: 25 }, // Package
      { wch: 15 }, // Pilgrim Type
      { wch: 15 }, // Nusuk Group
      { wch: 25 }, // Guide
      { wch: 25 }, // Organizer
      { wch: 15 }, // Status
      { wch: 10 }, // Is Owner
    ];

    // Create workbook and append worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Pilgrims');

    // Generate filename with current date
    const date = new Date().toISOString().split('T')[0];
    const filename = `pilgrims-data-${date}.xlsx`;

    // Save file
    XLSX.writeFile(wb, filename);

    return true;
  } catch (error) {
    console.error('Error exporting pilgrims data:', error);
    return false;
  }
};